const $$splitComponentImporter = () => import('/opt/buildhome/repo/src/routes/petso/dashboard/booking.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
export const Route = createFileRoute('/petso/dashboard/booking')({
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});